import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 32px;
`;

export const TopRow = styled.div`
    display: flex;
    align-items: center;
`;

export const HeaderTitle = styled(Typography)`
    color: ${({ theme }) => theme.colors.secondary.main};
    font-weight: 600;
    font-size: 18px;
    margin-right: 32px;
`;

export const AlertContainer = styled.div`
    width: 100%;
`;
